import { Component, OnInit, Input, Output, EventEmitter, } from '@angular/core';

@Component({
  selector: 'app-view-product',
  templateUrl: './view-product.component.html',
  styleUrls: ['./view-product.component.css']
})
export class ViewProductComponent implements OnInit {

  @Input() viewProductData: any;
  @Output() toggleForm = new EventEmitter<boolean>();

  public optionsLists: Array<any> = [];
  public optionsListsArray: Array<any> = [];
  public description: string;
  public name: string;
  public imgsrc: string;
  public colorType: string = 'image';

  constructor() { }

  ngOnInit() {
    this.description = this.viewProductData.description;
    this.optionsLists = this.viewProductData.options;

    //Convert Object to Array
    const mapped = Object.keys(this.optionsLists).map(key => ({ colorid: key, sizeid: this.optionsLists[key] }));
    for (var x in mapped) {
      //Convert Inner Object to Array
      const dd = Object.keys(mapped[x]['sizeid']).map(key => ({ size: key, value: mapped[x]['sizeid'][key] }));
      mapped[x]['sizeid'] = dd;
    }
    this.optionsListsArray = mapped;    

    //#region Test

    // for (var x in this.optionsLists) {
    //   this.optionColorIdArray.push(x);
    //   this.optionsLists.hasOwnProperty(x) && this.optionsListsArray.push(this.optionsLists[x]);
    // }
    //console.log(this.optionsListsArray);
    // for (var x in this.optionsListsArray) {
    //   let sizesListsArray: Array<any> = [];
    //   for (var y in this.optionsListsArray[x]) {
    //     this.optionSizeIdArray.push(y);
    //     //console.log(this.optionsListsArray[x]);
    //     this.optionsListsArray[x].hasOwnProperty(y) && sizesListsArray.push(this.optionsListsArray[x][y]);
    //     //console.log(sizesListsArray);
    //   }
    //   this.optionsListsArray[x] = sizesListsArray;
    // }
    //console.log(this.optionsListsArray);

    //#endregion

  }

  colorName = function (colorId, colors) {
    colors.forEach(x => {
      if (x.color_id == colorId) {
        this.name = x.name;
        this.imgsrc = x.color_image;
        this.colorType = x.image_type;
      }
    });
  }

  backToList(): void {
    this.toggleForm.emit();
  }

  getFirstColor(code: string): string {
    return code ? code.split(',')[0] : 'ffffff';
  }

}




// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-products/view-product/view-product.component.ts